<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <div class="mr-3">
        <span class="mr-2 mobile-hide">{{ authUser ? authUser.name : '' }}</span>
        <span class="fa fa-user"></span>
      </div>
    </template>
    <template slot="dropdown">
      <b-dropdown-item @click.passive="goToConfigPage"><i class="fa fa-cog" />Configurações</b-dropdown-item>
      <b-dropdown-item
        @click.passive="reloadProfile"
        :disabled="loading"
      >
        <i class="fa fa-refresh" :class="{ 'fa-spin': loading }" />Recarregar perfil
      </b-dropdown-item>
      <b-dropdown-item
        @click.passive="reloadParameter"
        :disabled="loading"
        class="reload-parameters-button"
      >
        <span>Recarregar parâmetros</span>
      </b-dropdown-item>
      <b-dropdown-item @click.passive="logout"><i class="fa fa-lock" />Logout</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import { auth } from '@/service'
import shared from '@/shared/shared'
import { httpClient } from '@/service'

const PROFILE_NOT_FOUND_MSG = 'Perfil não encontrado';

export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },

  props: {
    authUser: {
      type: Object,
      require
    }
  },

  data() {
    return {
      loading: false
    }
  },

  methods: {
    logout() {
      auth.logout();
    },

    goToConfigPage() {
      this.$router.push('/config');
    },

    reloadProfile() {
      if (this.loading) return;

      let authUser = shared.getAuthUser();

      if (!authUser || !authUser.profile || !authUser.profile.id) {
        this.$notify.textError(PROFILE_NOT_FOUND_MSG);
        return;
      }

      this.loading = true;
      httpClient
        .get(`${process.env.VUE_APP_API_URL}profiles/${authUser.profile.id}`)
        .then(({ data }) => {
          this.loading = false;
          let newProfile = data.data;

          if (newProfile) {
            authUser.profile = newProfile;
            this.updateUserAndReloadPage(authUser, "Perfil recarregado com sucesso, recarregando página...");
          } else {
            this.$notify.textError(PROFILE_NOT_FOUND_MSG);
          }
        })
        .catch((error) => {
          this.loading = false;
          if (error.message) {
            this.$notify.error(error);
          } else {
            this.$notify.textError("Houve um erro ao recarregar o perfil");
          }
        });
    },

    updateUserAndReloadPage(authUser, msg) {
      shared.setLocalStorageObj('auth/user', authUser);
      this.$notify.success(msg);

      setTimeout(() => {
        window.location.reload();
      }, 1500);
    },

    reloadParameter() {
      if (this.loading) return;

      let authUser = shared.getAuthUser();

      if (!authUser || !authUser.companyGroup) {
        this.$notify.textError('Erro: usuário ou grupo empresa não encontrados');
        return;
      }

      this.loading = true;
      httpClient.get(`${process.env.VUE_APP_API_URL}parameters?size=1`)
      .then(data => {
        this.loading = false;
        let parameters = data.data.data.content;

        if (!parameters || !parameters.length) {
          this.$notify.warn('Parâmetros não cadastrados');
        } else {
          this.authUser.companyGroup.parameter = parameters[0];
          this.updateUserAndReloadPage(authUser, "Parâmetros recarregados com sucesso, recarregando página...");
        }
      }).catch(error => {
        this.loading = false;

        if (error.message) {
          this.$notify.error(error)
        } else {
          this.$notify.textError("Houve um erro ao buscar os parâmetros");
        }
      });
    }
  }
}
</script>

<style>
.reload-parameters-button * {
  padding: 10px 3px;
}
</style>
